module.exports = __webpack_public_path__ + "img/news14_5.9ba6bba9.jpg";